import { getActionCreators, createTrackerStoreEnhancer } from '@csod/tracker';
import { AmplitudeAPI } from '@csod/tracker-vendor-amplitude';
import { TrackerWithStore } from '@csod/tracker-with-store';
export { TrackerWithStore } from '@csod/tracker-with-store';

// @ts-ignore
var getContext = function getContext() {
  return window['csod']['context'];
}; // @ts-ignore


var getVendorAPIKey = function getVendorAPIKey() {
  return getContext().trackerSettings.vendorAPIKeys.amplitude;
};

function getDefaultSettings() {
  var ctx = getContext();
  var debug = ctx.debug,
      env = ctx.env,
      trackerSettings = ctx.trackerSettings;
  var devMode = !!(debug || env === 'development');
  var apiKey = trackerSettings.vendorAPIKeys.amplitude;

  if (!apiKey) {
    // @ts-ignore
    var csod = window['csod'];

    if (csod && csod.utils.setDefaultAmplitudeAPIKey) {
      csod.utils.setDefaultAmplitudeAPIKey();
      apiKey = ctx.trackerSettings.vendorAPIKeys.amplitude;
    } else {
      throw new Error('Amplitude apiKey does not exist on context. Make sure you have the latest version of player-core.');
    }
  }

  var middlewareSettings = {
    env: devMode ? 'development' : 'production',
    anonymizeUserData: trackerSettings.anonymizePortalName ? ['userId', 'corp'] : ['userId']
  }; // try to get a fresh copy of the key if the context was created after the store was created

  var getAPIOptions = function getAPIOptions() {
    return Promise.resolve({
      apiKey: getVendorAPIKey() || apiKey
    });
  };

  return {
    middlewareSettings: middlewareSettings,
    getAPIOptions: getAPIOptions
  };
}

var getActionCreatorsAmplitude = function getActionCreatorsAmplitude() {
  return getActionCreators('amplitude');
};
function createTrackerStoreEnhancerWithDefaults() {
  var _getDefaultSettings = getDefaultSettings(),
      middlewareSettings = _getDefaultSettings.middlewareSettings,
      getAPIOptions = _getDefaultSettings.getAPIOptions;

  return createTrackerStoreEnhancer(middlewareSettings, AmplitudeAPI, getAPIOptions);
}
function createStoreWithDefaults(storeOptions) {
  var _getDefaultSettings2 = getDefaultSettings(),
      middlewareSettings = _getDefaultSettings2.middlewareSettings,
      getAPIOptions = _getDefaultSettings2.getAPIOptions;

  return new TrackerWithStore({
    middlewareSettings: middlewareSettings,
    API: AmplitudeAPI,
    getAPIOptions: getAPIOptions
  }, storeOptions);
}
var defaultContextKeys = ['user', 'corp', 'cultureName', 'timezone', 'correlation'];
function getUserProperties(contextKeys) {
  if (contextKeys === void 0) {
    contextKeys = defaultContextKeys;
  }

  var context = getContext(),
      result = {};

  if (context) {
    result = contextKeys.reduce(function (acc, key) {
      if (Object.prototype.hasOwnProperty.call(context, key)) {
        var targetKey = key; // @ts-ignore

        var targetVal = context[key];

        if (key === 'user') {
          targetKey = 'userId';
          var corp = context['corp'] || '';
          targetVal = "" + corp.toLowerCase() + targetVal;
        } // @ts-ignore


        acc[targetKey] = targetVal;
      }

      return acc;
    }, {});
  }

  return result;
}

export { getActionCreatorsAmplitude as getActionCreators, createTrackerStoreEnhancerWithDefaults, createStoreWithDefaults, defaultContextKeys, getUserProperties };



//////////////////
// WEBPACK FOOTER
// ../@csod/tracker-defaults/build/index.js
// module id = 229
// module chunks = 0